import { cn } from '@/lib/utils'
import { MAX_PROMPT_LENGTH, PROMPT_LENGTH_WARN_AT } from '../lib/promptLimits'

interface Props {
  /** Длина УЖЕ очищенного промпта — считает её вызывающий, он же гасит кнопку. */
  length: number
  /** Отступы/выравнивание — забота поверхности, не счётчика. */
  className?: string
  /**
   * Потолок текущего контракта. По умолчанию — промпт генерации; правка
   * блоков передаёт свой (`BLOCK_EDIT_PROMPT_MAX`): значения совпадают, но
   * контракты разные, и связывать их одной константой нельзя.
   */
  max?: number
}

/**
 * «N/2000» на подходе к лимиту. Обе поверхности старта (композер главной и
 * AI-сайдбар) обязаны объяснять молчаливый отказ одинаково, поэтому счётчик
 * общий и порог у него один — `PROMPT_LENGTH_WARN_AT`, второй копии нет.
 */
export const PromptCounter = ({ length, className, max }: Props) => {
  const limit = max ?? MAX_PROMPT_LENGTH
  // «Показываем на подходе» — то же самое правило для любого потолка, а не
  // второе захардкоженное число: разрыв до предупреждения фиксирован.
  const warnAt = limit - (MAX_PROMPT_LENGTH - PROMPT_LENGTH_WARN_AT)
  if (length < warnAt) return null
  return (
    <div className={cn('text-right', className)}>
      <span
        className={cn('text-xs', length > limit ? 'text-destructive' : 'text-muted-foreground')}
      >
        {length}/{limit}
      </span>
    </div>
  )
}
